export function setCookie(name: string, value: string) {
	// biome-ignore lint: lint/suspicious/noDocumentCookie
	document.cookie = `${name}=${encodeURIComponent(value)};path=/`;
}

export function removeCookie(name: string) {
	// biome-ignore lint: lint/suspicious/noDocumentCookie
	document.cookie = `${name}=; max-age=0;path=/`;
}

export function getCookie(name: string) {
	const cookies = document.cookie.split("; ");
	for (const cookie of cookies) {
		const [key, value] = cookie.split("=");
		if (key === name) {
			return decodeURIComponent(value);
		}
	}
	return null;
}
